import { productsConstants as constants } from '../../constants/products'

const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedData: null,
  isError: null,
  error: ''
}

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_ALL:
      return { ...state, allData: action.data}
    case constants.GET_DATA:
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case constants.GET_SELECT:
      return { ...state, selectedData: action.selectedData }

    case constants.GET_FAILURE:
        return { ...state, isError: true, error: action.error}

    default:
      return { ...state }
  }
}
export default productReducer
